import React, { Component } from 'react'

import {
    PlantCareListImage,
    PlantCareListItemContent,
    PlantCareItemName,
    PlantCareListItemInnerContent,
    PlantCareListItemCol
} from '../StyledComponents/Plants/PlantCare'
import { SelectionNavigator, SelectionNavigatorTitle } from '../StyledComponents/Selection'
import { DashboardRow, DashboardLink } from '../StyledComponents/Pages/Dashboard'

import withAuthorization from '../higherOrder/withAuthorization'
import { SETTINGS, PLANTS, DEVICES, CLASSIFIER } from '../../constants/routes'

const plantsIcon = require('../../assets/images/Dashboard/plants.jpeg')
const settingsIcon = require('../../assets/images/Dashboard/settings.jpeg')
const devicesIcon = require('../../assets/images/Dashboard/Devices.jpg')
const classifierIcon = require('../../assets/images/Dashboard/plantRecognition.jpg')

const renderCard = (card) => {
    const { title, link, icon } = card

    return (
        <PlantCareListItemCol xs="6" sm="4" md="3" key={link}>
            <DashboardLink to={`${link}`}>
                <PlantCareListItemContent>
                    <PlantCareListImage src={icon} contain={false} />
                    <PlantCareListItemInnerContent>
                        <PlantCareItemName>{title}</PlantCareItemName>
                    </PlantCareListItemInnerContent>
                </PlantCareListItemContent>
            </DashboardLink>
        </PlantCareListItemCol>
    )
}

class DashboardPage extends Component {
    constructor(props) {
        super(props)

        this.state = {
            cards: [
                {
                    title: 'Geräte',
                    icon: devicesIcon,
                    link: DEVICES,
                },
                {
                    title: 'Pflanzen',
                    icon: plantsIcon,
                    link: PLANTS,
                },
                {
                    title: 'Einstellungen',
                    icon: settingsIcon,
                    link: SETTINGS,
                },
                {
                    title: 'Pflanzenerkennung',
                    icon: classifierIcon,
                    link: CLASSIFIER,
                },
            ],
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        const cardItems = this.state.cards.map(card => renderCard(card))

        return (
            <div>
                <SelectionNavigator>
                    <SelectionNavigatorTitle>Dashboard</SelectionNavigatorTitle>
                </SelectionNavigator>
                <DashboardRow>
                    {cardItems}
                </DashboardRow>
            </div>
        )
    }
}

const authCondition = authUser => !!authUser

export default withAuthorization(authCondition)(DashboardPage)



// WEBPACK FOOTER //
// ./src/components/pages/Dashboard.js